// Percorso file: src/components/PastigliaCategoria.jsx
//
// PASTIGLIA CATEGORIA (doc 07 §2) — componente condiviso.
//
// Perché sta qui e non più dentro TeamAssignment.jsx: il CSS della
// pastiglia era già condiviso (src/components/AdminTools.css, §1
// «PASTIGLIE»), il JSX no — viveva locale alla pagina e non era
// esportato. La prima pagina che ne aveva bisogno fuori da Team
// Assignment (la home del genitore) avrebbe dovuto ricopiarlo: è
// esattamente il difetto che il progetto ha già pagato con le undici
// copie del gate dei ruoli. Il corpo NON è cambiato: sono le stesse
// funzioni di TeamAssignment.jsx, spostate.
//
// Il CSS lo importa questo file, non le pagine: chi usa la pastiglia
// non deve sapere in quale foglio vive. (AdminTools.css contiene solo
// selettori di classe con prefisso `qpsc-`: nessuna regola globale, e
// nessuna pagina viene toccata dal solo fatto di importarlo.)

import React from "react";
import { normalizza } from "../utils/roleUtils";
import "./AdminTools.css";

/** Le cinque categorie ufficiali del team (doc 07 §2). Nessun'altra. */
export const CATEGORIE = ["MEN", "BOYS", "WOMEN", "GIRLS", "MIXED"];

/**
 * Pastiglia della categoria (doc 07 §2): fondo trasparente, bordo e
 * testo dello stesso colore, dal tema.
 * Se la categoria non è una delle cinque non si inventa nulla: nella
 * modale Manage Teams si dichiara il vuoto, nella lista non si mostra
 * la pastiglia (vedi PastigliaCategoriaSeNota).
 */
export function PastigliaCategoria({ category }) {
  const categoria = normalizza(category);
  const nota = CATEGORIE.includes(categoria);

  return (
    <span className={`qpsc-pill qpsc-pill--${nota ? categoria.toLowerCase() : "none"}`}>
      {nota ? categoria : "NO CATEGORY"}
    </span>
  );
}

/** Come sopra, ma tace se la categoria non è nota. */
export function PastigliaCategoriaSeNota({ category }) {
  if (!CATEGORIE.includes(normalizza(category))) return null;
  return <PastigliaCategoria category={category} />;
}
